const BETA_INTEGRATION_SLUGS = new Set<string>([
  // Add integration slugs here to mark them as beta.
  'mountainwarehouse',
  'freemans',
  'argos',
  'urbanoutfitters',
  'macys',
  'kohls',
  'jcpenney',
  'bloomingdales',
  '1800flowers',
  'lowes',
  'bestbuyus',
  'nordstrom',
  'secretsales',
  'johnlewis'
]);

export const IsBetaIntegration = (integrationSlug?: string | null): boolean => {
  if (!integrationSlug) {
    return false;
  }

  return BETA_INTEGRATION_SLUGS.has(integrationSlug.trim().toLowerCase());
};
